import * as React from 'react'
import StageHeader from '../../shared/StageHeader'
import FormLayout from '../../shared/FormLayout'
import CheckboxWithLabelField from '../inputs/CheckboxWithLabelField'
import { useContractForm } from '@/modules/drivers/context/ContractFormContext'
import { Divider } from '../../shared/Divider'
import { FieldsetSelect } from '@/modules/settings/components/FieldsetSelect'
import useContractFieldSetOptions from '../options/useContractFieldSetOptions'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import {
  DriverQualificationsType,
  FieldsetSelectProps,
} from '@/modules/drivers/types/contracts'

const ContractEu = () => {
  const { t } = useLocalize()
  const { setData, data } = useContractForm()
  const {
    contractQualificationAustriaOptions,
    contractQualificationLuksemburgOptions,
    contractQualificationFinlandOptions,
    contractQualificationBelgiumOptions,
    contractQualificationCzechOptions,
    contractQualificationDenmarkOptions,
    contractQualificationItalyOptions,
    contractQualificationFranceOptions,
  } = useContractFieldSetOptions()
  const qualificationOptions: FieldsetSelectProps[] = [
    {
      label: t('contract.qualifications-austria'),
      value: data?.driverQualificationsAustria?.toString() ?? '',
      data: 'driverQualificationsAustria',
      required: true,
      placeholder: 'Wybierz...',
      options: contractQualificationAustriaOptions,
    },
    {
      label: t('contract.qualifications-belgium'),
      value: data?.driverQualificationsBelgium?.toString() ?? '',
      data: 'driverQualificationsBelgium',
      required: true,
      placeholder: 'Wybierz...',
      options: contractQualificationBelgiumOptions,
      children: (
        <p className="tw-cursor-pointer tw-text-sm tw-text-primary tw-underline">
          {t('contract.points-calculator')}
        </p>
      ),
    },
    {
      label: 'Kwalifikacje dla Czech',
      value: data?.driverQualificationsCzech?.toString() ?? '',
      data: 'driverQualificationsCzech',
      required: true,
      placeholder: 'Wybierz...',
      options: contractQualificationCzechOptions,
    },
    {
      label: 'Kwalifikacje dla Danii',
      value: data?.driverQualificationsDenmark?.toString() ?? '',
      data: 'driverQualificationsDenmark',
      required: true,
      placeholder: 'Wybierz...',
      options: contractQualificationDenmarkOptions,
    },
    {
      label: t('contract.qualifications-finland'),
      value: data?.driverQualificationsFinland?.toString() ?? '',
      data: 'driverQualificationsFinland',
      required: true,
      placeholder: 'Wybierz...',
      options: contractQualificationFinlandOptions,
    },
    {
      label: t('contract.qualifications-france'),
      value: data?.driverQualificationsFrance?.toString() ?? '',
      data: 'driverQualificationsFrance',
      required: true,
      placeholder: 'Wybierz...',
      options: contractQualificationFranceOptions,
    },
    {
      label: t('contract.qualifications-luxembourg'),
      value: data?.driverQualificationsLuxembourg?.toString() ?? '',
      data: 'driverQualificationsLuxembourg',
      required: true,
      placeholder: 'Wybierz...',
      options: contractQualificationLuksemburgOptions,
    },
    {
      label: t('contract.qualifications-italy'),
      value: data?.driverQualificationsItaly?.toString() ?? '',
      data: 'driverQualificationsItaly',
      required: true,
      placeholder: 'Wybierz...',
      options: contractQualificationItalyOptions,
    },
  ]
  return (
    <div className="tw-flex tw-min-h-[500px] tw-justify-between">
      <StageHeader title={t('contract.taxes-and-deductions')} />
      <FormLayout>
        <>
          <CheckboxWithLabelField
            field="skipForeignMinimalAmountCalculation"
            data={data}
            setData={setData}
            label={t('contract.skip-min-wage-calculation')}
          />
          <Divider />
        </>
        <div className="tw-space-y-4">
          {qualificationOptions.map((q) => {
            return (
              <React.Fragment key={q.label}>
                <FieldsetSelect
                  required={q.required}
                  label={q.label}
                  placeholder={q.placeholder}
                  value={q.value?.toString()}
                  overflow
                  optionAlign="start"
                  name="type"
                  valueClassName="!tw-h-auto tw-min-h-9 tw-py-2"
                  onChange={(e) => {
                    setData({
                      ...data,
                      [q.data]: e.target.value as DriverQualificationsType,
                    })
                  }}
                  options={q.options}
                />
                {q?.children}
              </React.Fragment>
            )
          })}
        </div>
      </FormLayout>
    </div>
  )
}

export default ContractEu
